import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

// Helpers
import { buildDTOFromFlattenedManifest } from '../../common/helpers/buildDTOFromFlattenedManifest';

/**
 * Builds predicate manifest from store
 * @param {[string]} rootPredicateIds
 * @returns object | null
 */
export const useCriteriaStoreBuildDTO = () => {
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const predicates = useStore(store, (s) => s.predicates);
    const builder = React.useCallback(
        (data) => {
            const flattenedDTO = {
                ...data,
                predicates: [...(data.predicates ?? [])].map((root) =>
                    buildDTOFromFlattenedManifest(root, { ...predicates })
                )
            };

            if (Object.hasOwn(data, 'predicateParts')) {
                flattenedDTO.predicateParts = [...(data.predicateParts ?? [])].map((root) =>
                    buildDTOFromFlattenedManifest(root, { ...predicates })
                );
            }
            return flattenedDTO;
        },
        [predicates]
    );

    return builder;
};
